import { collection, query, where, getDocs, orderBy, limit, doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/db';

// Fetch products by category
export const getProductsByCategory = async (category, limitCount = 10) => {
  try {
    const productsRef = collection(db, 'products');
    const q = query(
      productsRef,
      where('categories', 'array-contains', category),
      where('isActive', '==', true),
      orderBy('createdAt', 'desc'),
      limit(limitCount)
    );
    
    const querySnapshot = await getDocs(q);
    const products = [];
    
    querySnapshot.forEach((doc) => {
      products.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return products;
  } catch (error) {
    console.error('Error fetching products by category:', error);
    
    // If the composite index doesn't exist, try a simpler query
    if (error.code === 'failed-precondition' || error.message.includes('index')) {
      try {
        const productsRef = collection(db, 'products');
        const q = query(
          productsRef,
          where('categories', 'array-contains', category),
          where('isActive', '==', true)
        );
        
        const querySnapshot = await getDocs(q);
        const products = [];
        
        querySnapshot.forEach((doc) => {
          products.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        return products;
      } catch (fallbackError) {
        console.error('Fallback query also failed:', fallbackError);
        return [];
      }
    }
    
    return [];
  }
};

// Fetch featured products for homepage
export const getFeaturedProducts = async (limitCount = 6) => {
  try {
    const productsRef = collection(db, 'products');
    const q = query(
      productsRef,
      where('categories', 'array-contains', 'featured'),
      where('isActive', '==', true),
      orderBy('createdAt', 'desc'),
      limit(limitCount)
    );
    
    const querySnapshot = await getDocs(q);
    const products = [];
    
    querySnapshot.forEach((doc) => {
      products.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return products;
  } catch (error) {
    console.error('Error fetching featured products:', error);
    return [];
  }
};

// Fetch all active products
export const getAllProducts = async () => {
  try {
    const productsRef = collection(db, 'products');
    const q = query(
      productsRef,
      where('isActive', '==', true),
      orderBy('createdAt', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    const products = [];
    
    querySnapshot.forEach((doc) => {
      products.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return products;
  } catch (error) {
    console.error('Error fetching all products:', error);
    
    // If the composite index doesn't exist, try a simpler query
    if (error.code === 'failed-precondition' || error.message.includes('index')) {
      try {
        const productsRef = collection(db, 'products');
        const q = query(
          productsRef,
          where('isActive', '==', true)
        );
        
        const querySnapshot = await getDocs(q);
        const products = [];
        
        querySnapshot.forEach((doc) => {
          products.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        return products;
      } catch (fallbackError) {
        console.error('Fallback query also failed:', fallbackError);
        return [];
      }
    }
    
    return [];
  }
};

// Fetch a single product by ID
export const getProductById = async (productId) => {
  try {
    const productRef = doc(db, 'products', productId);
    const productDoc = await getDoc(productRef);
    
    if (productDoc.exists()) {
      return {
        id: productDoc.id,
        ...productDoc.data()
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching product by ID:', error);
    return null;
  }
};

// Search products by title or description
export const searchProducts = async (searchTerm, category = null) => {
  try {
    const productsRef = collection(db, 'products');
    let q = query(
      productsRef,
      where('isActive', '==', true),
      orderBy('title')
    );
    
    if (category) {
      q = query(
        productsRef,
        where('categories', 'array-contains', category),
        where('isActive', '==', true),
        orderBy('title')
      );
    }
    
    const querySnapshot = await getDocs(q);
    const products = [];
    
    querySnapshot.forEach((doc) => {
      const product = {
        id: doc.id,
        ...doc.data()
      };
      
      // Simple search filter
      const searchLower = searchTerm.toLowerCase();
      if (
        product.title?.toLowerCase().includes(searchLower) ||
        product.description?.toLowerCase().includes(searchLower)
      ) {
        products.push(product);
      }
    });
    
    return products;
  } catch (error) {
    console.error('Error searching products:', error);
    return [];
  }
};
